import React from 'react';
import Switch from '@mui/material/Switch';
import { CircularProgress } from '@mui/material';
import { useDispatch } from 'react-redux';

import {
  IgnorableNotificationMessageCategory,
  NotificationChannelType,
  NotificationSettingsPageQuery,
  useSetOrganizationNotificationCategorySettingMutation,
} from 'generated/graphql';
import { showErrorAction } from 'containers/Notification/actions';

export const CategorySwitch = ({
  categoryId,
  data,
}: {
  categoryId: IgnorableNotificationMessageCategory;
  data: NotificationSettingsPageQuery;
}) => {
  const dispatch = useDispatch();
  const categoryIsMuted =
    data.organizationNotificationSettings?.email?.mutedCategories.includes(categoryId);
  const [setOrganizationNotificationCategorySetting, { loading }] =
    useSetOrganizationNotificationCategorySettingMutation({
      onError: () => {
        dispatch(showErrorAction('An error occurred, please try again.'));
      },
    });
  if (loading) {
    return <CircularProgress style={{ marginLeft: 8, width: 38, height: 38 }} />;
  }
  return (
    <Switch
      checked={!categoryIsMuted}
      inputProps={{ 'aria-label': 'controlled' }}
      onChange={(event) => {
        void setOrganizationNotificationCategorySetting({
          variables: {
            channel: NotificationChannelType.Email,
            categoryId,
            muted: !event.target.checked,
          },
        });
      }}
    />
  );
};
